module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.8.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.11.0.0.box.607.434.576.47.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP12.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.11.0.0.box.607.434.576.47.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("List ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP13.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP13.w.10.0.0"
    }
  }), _vm._v("Illustrations ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.11.1.0.box.174.514.1434.2033.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic][subsumed]",
      "src": "data/content-0007.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.12.0.0.box.163.194.1426.1711.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0008.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP14.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.0.0.box.351.519.1122.1149.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP14.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.13.0.0.box.715.519.400.34.q.50"
    }
  }, [_vm._v("SLEEP! SLEEP!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP14.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.13.0.1.box.617.625.591.38.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14.w.2.0.0"
    }
  }), _vm._v("By "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mrs. ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Edgar ")]), _vm._v("A. Coco, "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sr. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP14.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    attrs: {
      "id": "para.13.0.2.box.351.725.1122.313.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14.w.3.0.0"
    }
  }), _vm._v("'Neath ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stars ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stripes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("where ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("poppies ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("grow, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("We ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("met ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("over ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("there ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("downed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("foe. ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Yet ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("again ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whim ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("nation ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Would ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("seek ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rule ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whole ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("creation. ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sleep! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sleep! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("We'll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fail ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Flander's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Field ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("till ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Liberty ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rings ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("everywhere, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("we'll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("yield. ")]), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP14.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.13.0.3.box.838.1155.154.32.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14.w.4.0.0"
    }
  }), _vm._v("Chorus ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP14.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    attrs: {
      "id": "para.13.0.4.box.351.1253.1064.415.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP14.w.5.0.0"
    }
  }), _vm._v("Fly! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oh, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fly! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Back ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("across ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("deep ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("blue ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sea, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oh! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stars ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stripes, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("own ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("home ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be; ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bring ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("back ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("torch ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pledged ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("keep ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Flanders ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("they ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("their ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sleep. ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hold ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("high! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hold ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("high! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oh, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hand ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Destiny, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("burning ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("torch ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("liberty. ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("America! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("we ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stand ")]), _c('i', [_vm._v("with you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dare! ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("America! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("we ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bow ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thee ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("prayer! ")]), _c('br')])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1b3954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0009.vue
// module id = 57
// module chunks = 0